import { Fragment } from "react";
import LoadingSpinner from "../LoadingSpinner";
import avatar from "../../assets/svg/avatar.svg";
import { Menu, Transition } from "@headlessui/react";
import { CogIcon, ChevronRightIcon } from "@heroicons/react/solid";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default function UserAvatarDropdown({
  profilePictureUrl,
  className,
  loading = false,
  alt = "Profile Picture",
  onClick,
  userName,
  email,
}: {
  profilePictureUrl: string | null | undefined;
  className?: string;
  userName?: string;
  email?: string;
  loading?: boolean;
  size?: number;
  alt?: string;
  onClick?: () => void;
}) {
  const auth = useAuth();
  const { t } = useTranslation();
  if (loading) {
    return <LoadingSpinner size={64} />;
  }

  return (
    <Menu as="div" className="relative inline-block ">
      <div>
        <Menu.Button className="inline-flex w-full justify-center rounded-md    px-4 py-2 text-sm font-medium  ">
          <img
            src={profilePictureUrl || avatar}
            className={`rounded-full overflow-hidden object-cover bg-gray-100 text-brandblue-500 text-sm ${
              className ? className : "h-16 w-16"
            }`}
            alt={alt}
            key={profilePictureUrl}
            onClick={onClick}
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={classNames(
            i18next.language == "ar" ? "right-0 " : "left-0 ",
            "p-6 absolute z-[1000] mt-2 w-[296px] origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          )}
        >
          <div className="py-1">
            <Menu.Item>
              <div className="flex">
                <div
                  className={classNames(
                    i18next.language == "ar" ? "ml-4 " : "mr-4 ",
                    " flex-shrink-0"
                  )}
                >
                  <img
                    src={profilePictureUrl || avatar}
                    className={`rounded-full overflow-hidden object-cover bg-gray-100 text-brandblue-500 text-sm ${
                      className ? className : "h-16 w-16"
                    }`}
                    alt={alt}
                    key={profilePictureUrl}
                    onClick={onClick}
                  />
                </div>
                <div>
                  <h4 className="text-sm">{userName}</h4>
                  <p className="text-sm text-gray-500">{email}</p>
                </div>
              </div>
            </Menu.Item>
          </div>
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <Link
                  to={`/${auth?.userType}/dashboard/personal-info?tab=${
                    auth?.userType === "tutor"
                      ? 3
                      : auth?.userType === "supervisor"
                      ? 1
                      : 2
                  }`}
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "group flex items-center  py-2 text-sm"
                  )}
                >
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center w-full">
                      <CogIcon
                        className="mx-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                        aria-hidden="true"
                      />
                      {t("changePassword")}
                    </div>
                    <ChevronRightIcon
                      className={classNames(
                        i18next.language == "ar" ? "rotate-180	 " : "",
                        "h-6 w-6 text-gray-400 group-hover:text-gray-500"
                      )}
                      aria-hidden="true"
                    />
                  </div>
                </Link>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <Link
                  to={`/${auth?.userType}/dashboard/personal-info`}
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "group flex items-center  py-2 text-sm"
                  )}
                >
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center w-full">
                      <CogIcon
                        className="mx-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                        aria-hidden="true"
                      />
                      {t("settings")}
                    </div>
                    <ChevronRightIcon
                      className={classNames(
                        i18next.language == "ar" ? "rotate-180	 " : "",
                        "h-6 w-6 text-gray-400 group-hover:text-gray-500"
                      )}
                      aria-hidden="true"
                    />
                  </div>
                </Link>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
